module.exports = __webpack_public_path__ + "static/media/JosefinSans-Regular.38107321.ttf";